/**
 * ViewDisabledIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const ViewDisabledIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M9.022 11.23v-.16a3 3 0 0 1 3-3h.16z" />
    <path
      fillRule="evenodd"
      d="m21.172 4.74-1.83 1.84a12 12 0 0 1 3.38 4.05 1 1 0 0 1 0 .88 12 12 0 0 1-14.31 6l-2.75 2.75a1 1 0 1 1-1.38-1.45l15.52-15.52a1 1 0 0 1 1.52.13 1 1 0 0 1-.15 1.32m-10.97 10.98c.58.23 1.197.348 1.82.35a5 5 0 0 0 4.66-6.82l-1.66 1.66v.16a3 3 0 0 1-3 3h-.16z"
      clipRule="evenodd"
    />
    <path d="M7.152 9.96a4.9 4.9 0 0 0 .22 2.93l-2.68 2.68a12.2 12.2 0 0 1-3.37-4.06 1 1 0 0 1 0-.88 12 12 0 0 1 14.31-6l-1.79 1.79a4.9 4.9 0 0 0-2.94-.22 5 5 0 0 0-3.75 3.76" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const ViewDisabledIcon = makeIcon('ViewDisabledIcon', ViewDisabledIconSvg)
